var _classCallCheck = require("/codebuild/output/src2867/src/s3/01/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/codebuild/output/src2867/src/s3/01/node_modules/@babel/runtime/helpers/createClass.js");
var _require = require('./errors'),
  InvalidLoanError = _require.InvalidLoanError;
var Loan = /*#__PURE__*/function () {
  "use strict";

  function Loan(attributes) {
    _classCallCheck(this, Loan);
    this.amount = attributes.amount;
    this.arrangementFee = attributes.arrangementFee || 0;
    this.administrationFee = attributes.administrationFee || 0;
    this.interest = attributes.interest;
    this.repaymentTime = attributes.repaymentTime;
    this.monthlyPayment = attributes.monthlyPayment;
  }
  _createClass(Loan, [{
    key: "getPayments",
    value: function getPayments() {
      if (!this.isValid()) {
        throw this.error;
      }
      if (this.cachedPayments == null) {
        this.cachedPayments = this.calculatePayments();
      }
      return this.cachedPayments;
    }
  }, {
    key: "getTotalCost",
    value: function getTotalCost() {
      if (!this.isValid()) {
        throw this.error;
      }
      return this.getPayments().reduce(function (total, value) {
        return total + value;
      }, 0) + this.arrangementFee;
    }
  }, {
    key: "getAPR",
    value: function getAPR() {
      if (!this.isValid()) {
        throw this.error;
      }
      var npv = function npv(cashFlow, apr) {
        var NPV = 0;
        for (var _i = 0; _i < cashFlow.length; _i += 1) {
          NPV += cashFlow[_i] / Math.pow(1 + apr, _i);
        }
        return NPV;
      };
      var cashFlow = [-(this.amount - this.arrangementFee)].concat(this.getPayments());
      var diff = 1;
      var x1 = 0;
      var x2 = this.interest;
      var i = 0;
      while (diff > 0.00001) {
        var npv1 = npv(cashFlow, x1);
        var npv2 = npv(cashFlow, x2);
        var x3 = Math.max(0, x2 - npv2 * ((x2 - x1) / (npv2 - npv1)));
        if (Number.isNaN(x3)) {
          return null;
        }
        diff = Math.abs(x3 - x1);
        x1 = x2;
        x2 = x3;
        i += 1;
        if (i > 1000) {
          return null;
        }
      }
      return Math.pow(1 + x2, 12) - 1;
    }
  }, {
    key: "getRepaymentTime",
    value: function getRepaymentTime() {
      if (!this.isValid()) {
        throw this.error;
      }
      if (this.repaymentTime != null) {
        return this.repaymentTime;
      }
      return this.calculateRepaymentTime();
    }
  }, {
    key: "isValid",
    value: function isValid() {
      this.error = null;
      if (!(this.amount > 0)) {
        this.error = new InvalidLoanError('amount is not a positive number');
        return false;
      }
      if (!(this.arrangementFee >= 0)) {
        this.error = new InvalidLoanError('arrangementFee is positive number');
        return false;
      }
      if (!(this.administrationFee >= 0)) {
        this.error = new InvalidLoanError('administrationFee is positive number');
        return false;
      }
      if (!(this.interest > 0)) {
        this.error = new InvalidLoanError('interest is not a positive number');
        return false;
      }
      if (this.repaymentTime == null && this.monthlyPayment == null) {
        this.error = new InvalidLoanError('repaymentTime or monthlyPayment must be defined');
        return false;
      }
      if (this.repaymentTime != null && this.monthlyPayment != null) {
        this.error = new InvalidLoanError('repaymentTime and monthlyPayment cannot both be defined');
        return false;
      }
      if (this.repaymentTime != null && !(this.repaymentTime > 0)) {
        this.error = new InvalidLoanError('repaymentTime is not a positive number');
        return false;
      }
      if (this.monthlyPayment != null && !(this.monthlyPayment > 0)) {
        this.error = new InvalidLoanError('monthlyPayment is not a positive number');
        return false;
      }
      return true;
    }
  }]);
  return Loan;
}();
module.exports = Loan;